import type { FlaggedContent } from "@circle-react/types";
import { Typography } from "@circleco/compass/components/Typography";

import { useVisibilityDescription } from "@/react/components/ModerationInfo/ModerationInfoModal/useVisibilityDescription";

interface VisibilityInfoProps {
  content?: FlaggedContent;
}

export const VisibilityInfo = ({ content }: VisibilityInfoProps) => {
  const visibilityMessage = useVisibilityDescription(content);

  if (!visibilityMessage) {
    return null;
  }

  return (
    <div className="flex items-center gap-4 pt-4">
      <Typography variant="label-sm">{visibilityMessage}</Typography>
    </div>
  );
};
